// @flow

import getPinTypes from 'app/common/react/components/PinRep/utils/getPinTypes';
import { getProductMerchant } from 'app/common/lib/CommerceUtil';
import { type Pin } from 'app/common/react/components/PinRep/types';

export default function getPinSourceText(pin: Pin): string {
  const { isProduct } = getPinTypes(pin);

  if (isProduct) {
    return getProductMerchant(pin) || '';
  }

  return '';
}
